/**
 * First-party event logging. Every event pushed to the GTM dataLayer is also
 * stored in the `site_events` table so the admin dashboard can chart it
 * without depending on Google Analytics.
 */
import { getAdConsent, hasGlobalPrivacyControl } from "./consent";
import { getSessionId, getVisitorId } from "./visitor";
import { deferIdle } from "./deferIdle";

export const logSiteEvent = (
  eventName: string,
  params: Record<string, unknown> = {},
) => {
  if (typeof window === "undefined") return;
  // Fire-and-forget, and deferred off the critical path so the insert never
  // competes with LCP resources for bandwidth/connections.
  const send = () => void (async () => {
    try {
      const { supabase } = await import("@/integrations/supabase/client");
      await supabase.from("site_events").insert({
        visitor_id: getVisitorId(),
        session_id: getSessionId(),
        event_name: eventName,
        page_path: window.location.pathname,
        referrer: document.referrer || null,
        params: params as never,
        ad_consent: getAdConsent(),
        gpc: hasGlobalPrivacyControl(),
      });
    } catch {
      /* ignore analytics failures */
    }
  })();

  deferIdle(send);
};
